import { Box } from '@mui/material';
import React, { useState } from 'react';

export default function useTabChange(initialValue = 0) {
  const [value, setValue] = useState(initialValue);

  /**
   * @function handleChange
   * @description Handle tab change
   * @param {object} event
   * @param {number} newValue
   * @returns {void}
   * @example handleChange(event, newValue)
   */
  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return [value, handleChange];
}

/**
 * @function TabPanel
 * @description Tab panel
 * @param {object} props
 * @returns {JSX.Element}
 * @example <TabPanel value={value} index={0}>Tab 1</TabPanel>
 */

export function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index, ...other } = props;

  return (
    <Box
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </Box>
  );
}
